import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdatCrmIdsResultModal} from './update-crm-ids.result.modal';
import {
    clearResult,
    selectUpdateCrmIdsShown,
    selectUpdateCrmIdsTask,
    selectUpdateCrmIdsUuid,
} from './update-crm-ids.slice';

export const UpdateCrmIdsResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateCrmIdsUuid}
        actionTaskSelector={selectUpdateCrmIdsTask}
        actionShownSelector={selectUpdateCrmIdsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UpdatCrmIdsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
